// Mock data for IELTS Dashboard

export const scoreData = {
  averageScore: "7 / 9",
  targetScore: "7 / 9",
  examIn: "08 Days"
};

export const fullTests = [
  {
    id: 1,
    title: "Cambridge - 11 Test 01",
    time: "2h:30m",
    difficulty: "Easy"
  },
  {
    id: 2,
    title: "Cambridge - 11 Test 01",
    time: "2h:30m",
    difficulty: "Easy"
  },
  {
    id: 3,
    title: "Cambridge - 11 Test 01",
    time: "2h:30m",
    difficulty: "Easy"
  },
  {
    id: 4,
    title: "Cambridge - 11 Test 01",
    time: "2h:30m",
    difficulty: "Easy"
  },
  {
    id: 5,
    title: "Cambridge - 11 Test 01",
    time: "2h:30m",
    difficulty: "Easy"
  }
];

export const testFilters = [
  { value: "All", label: "All" },
  { value: "Cambridge", label: "Cambridge" },
  { value: "British Council", label: "British Council" },
  { value: "IDP", label: "IDP" }
];

export const sections = [
  {
    id: 1,
    title: "Listening",
    count: 40,
    icon: "listening"
  },
  {
    id: 2,
    title: "Reading",
    count: 40,
    icon: "reading"
  },
  {
    id: 3,
    title: "Writing",
    count: 40,
    icon: "writing"
  },
  {
    id: 4,
    title: "Speaking",
    count: 40,
    icon: "speaking"
  }
];

export const sectionalTests = [
  {
    id: 1,
    title: "Cambridge - 11 Test - 01 Listening",
    time: "00:30m",
    difficulty: "Easy"
  },
  {
    id: 2,
    title: "Cambridge - 11 Test - 01 Listening",
    time: "00:30m",
    difficulty: "Hard"
  },
  {
    id: 3,
    title: "Cambridge - 11 Test - 01 Listening",
    time: "00:30m",
    difficulty: "Med"
  },
  {
    id: 4,
    title: "Cambridge - 11 Test - 01 Listening",
    time: "00:30m",
    difficulty: "Med"
  }
]; 